module.exports = __webpack_public_path__ + "img/zhuanli2.35c00fff.png";